import React from "react";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV } from "../../common/roles/constants";
import useRolesRestrictions from "../../common/roles/useRolesRestrictions";
import { RequiredRoles } from "../../search/criteria/components/common/requiredRoles";
import useSearchState from "../../search/useSearchState";
import { Ad } from "../sidebar/ads/Ad";
import { NewsItem } from "./item/NewsItem";
import { FreeUsersRestrictedText } from "./item/restricted/FreeUsersRestrictedText";
import { resultsDisplayType } from "../../common/types/search/results";
import { newsItemType } from "../../common/types/search/news";

export function NewsSearchResult({ forPrint }: resultsDisplayType) {
	const { rows, currentInput } = useSearchState(["display"]);
	const { isMobile } = useAccessWindowSize();
	const { hasRequiredToOpenRoles } = useRolesRestrictions(
		RequiredRoles.openFor([USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV]),
	);
	const summary = currentInput.get("display") === "summary";
	let adId = 0;

	if (forPrint) {
		return null;
	}

	const news = rows.map((item: newsItemType, index: number) => {
		if (!hasRequiredToOpenRoles && index === 2) {
			return (
				<React.Fragment key={index}>
					<NewsItem item={item} summary={summary} />
					<FreeUsersRestrictedText />
				</React.Fragment>
			);
		}

		if (isMobile && (index + 1) % 3 === 0 && index < 14) {
			adId++;

			return (
				<React.Fragment key={index}>
					<NewsItem item={item} summary={summary} />
					<Ad code={`sidebar_${adId}`} />
				</React.Fragment>
			);
		}

		return <NewsItem key={index} item={item} summary={summary} />;
	});

	return <div className="news-list">{news}</div>;
}
